
// import { useNavigate } from "react-router-dom";
import CustomersSay from "./CustomersSay";
import Specials from "./Specials";
import Chicago from "./Chicago";
// import BookingPage from "./BookingPage";
import CallToAction from "./CallToAction";


function Main() {

  return (
    <>
      <CallToAction />
      {/* <BookingPage /> */}
      <Specials />
      <CustomersSay />
      <Chicago />
    </>
  );
}

export default Main;
